export const UserActions = {
    SAVE_USER: 'SAVE_USER',
    RESET: 'RESET'
};